import * as m from '~/paraglide/messages'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/shared/ui/card'
import { Input } from '~/shared/ui/input'
import { Label } from '~/shared/ui/label'

interface ListingContactSectionProps {
  // biome-ignore lint/suspicious/noExplicitAny: TanStack Form API
  form: any
}

export function ListingContactSection({ form }: ListingContactSectionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{m.contactInformation()}</CardTitle>
        <CardDescription>{m.howCanCustomersReachYou()}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <form.Field name="phone">
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="space-y-2">
              <Label htmlFor={field.name}>{m.phoneNumberOptional()}</Label>
              <Input
                id={field.name}
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder={m.phonePlaceholder()}
                type="tel"
              />
            </div>
          )}
        </form.Field>

        <form.Field name="email">
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="space-y-2">
              <Label htmlFor={field.name}>{m.emailOptional()}</Label>
              <Input
                id={field.name}
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder={m.contactBusinessexamplecom()}
                type="email"
              />
              {field.state.meta.errors.length > 0 && (
                <p className="text-destructive text-sm">{field.state.meta.errors[0]}</p>
              )}
            </div>
          )}
        </form.Field>

        <form.Field name="website">
          {/* biome-ignore lint/suspicious/noExplicitAny: TanStack Form field API */}
          {(field: any) => (
            <div className="space-y-2">
              <Label htmlFor={field.name}>{m.websiteOptional()}</Label>
              <Input
                id={field.name}
                name={field.name}
                value={field.state.value}
                onBlur={field.handleBlur}
                onChange={(e) => field.handleChange(e.target.value)}
                placeholder={m.httpswwwyourbusinesscom()}
                type="url"
              />
              {field.state.meta.errors.length > 0 && (
                <p className="text-destructive text-sm">{field.state.meta.errors[0]}</p>
              )}
            </div>
          )}
        </form.Field>
      </CardContent>
    </Card>
  )
}
